import React from 'react';
import BlogCard from '../components/Blog/BlogCard';
import '../styles/Blog.css';

const Blog = () => {
  const blogPosts = [
    {
      id: 1,
      title: 'Top Renovation Tips',
      excerpt: 'Top Renovation Tips to Increase Your Property’s Value Before Selling.',
      image: 'blog1.png',
      slug: 'top-renovation-tips',
    },

    // Add more blog posts here
  ];

  return (
    <section className='section text-center'>
      <h1>Our Blog</h1>
      <p className='blogSubtitle'>Stay up-to-date with the latest industry news</p>
      <div className='blogGrid'>
        {blogPosts.map((post) => (
          <BlogCard key={post.id} post={post} />
        ))}
      </div>
      
    </section>

  );
};

export default Blog;